import { render, staticRenderFns } from "./TSI_SettingsWindow.vue?vue&type=template&id=3bad7ff2&scoped=true"
import script from "./TSI_SettingsWindow.vue?vue&type=script&lang=js"
export * from "./TSI_SettingsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad7ff2",
  null
  
)

export default component.exports